var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1611 7.51659C13.1611 4.47097 10.6902 2 7.64455 2C7.1561 2 6.72512 1.56902 6.72512 1.08057C6.72512 0.563388 7.1561 0.161137 7.64455 0.161137C11.7245 0.161138 15 3.43661 15 7.51659C15 11.5678 11.7245 14.872 7.64455 14.872C7.1561 14.872 6.72512 14.4411 6.72512 13.9526C6.72512 13.4354 7.1561 13.0332 7.64455 13.0332C10.6902 13.0332 13.1611 10.5622 13.1611 7.51659ZM3.79443 11.3667L0.576425 8.14869C0.202907 7.80391 0.202907 7.20053 0.576425 6.85574L3.79443 3.63774C4.13922 3.26422 4.7426 3.26422 5.08738 3.63774C5.4609 3.98252 5.4609 4.5859 5.08738 4.93069L3.44965 6.59715L9.48341 6.59715C10.0006 6.59716 10.4028 6.99941 10.4028 7.51659C10.4028 8.00503 10.0006 8.43602 9.48341 8.43602L3.44965 8.43602L5.08738 10.0738C5.4609 10.4185 5.4609 11.0219 5.08738 11.3667C4.7426 11.7402 4.13922 11.7402 3.79443 11.3667Z",
    fill: "#6D7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/BackButton.583c5bd7e3fa095705499b9741e21ff7.svg";
export { ForwardRef as ReactComponent };